/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaOverlayContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaOverlayContent({
  children,
  viewPath = "/DesignSystem/TysiaOverlay/TysiaOverlayContent",
  width = "100%",
  backgroundColor,
  paddingLeft = 0,
  paddingRight = 0,
  paddingTop = 0,
  paddingBottom = 0,
  flexGrow = 1,
  flexShrink = 1,
  flexBasis = 0,
  overflowY = "hidden"
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let backgroundColorOrdtColorsNeutral100 = backgroundColor ?? dtColorsNeutral100
  return (<React.Fragment
>
<div
  data-testid="TysiaOverlayContent.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-BLz8c': typeof width === 'number' ? `${width}px` : width,'--bc-2-BLz8c': backgroundColorOrdtColorsNeutral100,'--pl-3-BLz8c': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-4-BLz8c': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-5-BLz8c': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-6-BLz8c': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--fg-7-BLz8c': flexGrow,'--fs-8-BLz8c': flexShrink,'--fb-9-BLz8c': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--oy-10-BLz8c': overflowY}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}